import { createContext, useContext } from "react";

/** True while welcome credits should finish before a deep-linked tool popup opens. */
const DashboardToolEntryGateContext = createContext(false);

export function DashboardToolEntryGateProvider({ hold = false, children }) {
  return (
    <DashboardToolEntryGateContext.Provider value={Boolean(hold)}>
      {children}
    </DashboardToolEntryGateContext.Provider>
  );
}

export function useHoldDashboardToolEntry() {
  return useContext(DashboardToolEntryGateContext);
}
